exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-block[data-v-26914a0b] {\n  padding: 0 !important;\n}\n.badge.badge-primary.badge-pill[data-v-26914a0b] {\n  box-sizing: border-box;\n  margin-right: 2px;\n  margin-bottom: 2px;\n}\n", ""]);

// exports
